<script setup>

import facebook from '@i/facebook.svg';
import instagram from '@i/instagram.svg';
import linkedIn from '@i/linkedIn.svg';
import Icon from '@/Components/Icon.vue';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const options = computed(() => usePage().props.template_options);
</script>

<template>
    <div>
        <p
            v-if="options.footer.social_footer_title"
            class="mb-4 mt-8 text-xl font-black md:mt-0 md:text-3xl"
        >
            {{ options.footer.social_footer_title }}
        </p>

        <div
            v-if="options.footer.social_footer_text"
            class="whitespace-pre-wrap"
            v-html="options.footer.social_footer_text"
        />

        <div class="mt-3 flex gap-3">
            <a
                v-if="options.socials.facebook"
                :href="options.socials.facebook"
                class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-inverted text-black transition-colors hover:bg-primary-inverted-hover"
                target="_blank"
            >
                <Icon
                    :icon="facebook"
                    :icon-dutch="facebook"
                    alt="facebook icon"
                    class="h-auto w-3"
                />
            </a>
            <a
                v-if="options.socials.instagram"
                :href="options.socials.instagram"
                class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-inverted text-black transition-colors hover:bg-primary-inverted-hover"
                target="_blank"
            >
                <Icon
                    :icon="instagram"
                    :icon-dutch="instagram"
                    alt="instagram icon"
                    class="h-auto w-4"
                />
            </a>
            <a
                v-if="options.socials.linkedin"
                :href="options.socials.linkedin"
                class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-inverted text-black transition-colors hover:bg-primary-inverted-hover"
                target="_blank"
            >
                <Icon
                    :icon="linkedIn"
                    :icon-dutch="linkedIn"
                    alt="linkedin icon"
                    class="h-auto w-4"
                />
            </a>
        </div>
    </div>
</template>
